package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.codegen.internal.ExprSerializer
import top.wcpe.allincore.dsl.compiler.codegen.internal.NumberNormalizer
import top.wcpe.allincore.dsl.ir.model.UiBinding

/**
 * 把单个属性右值表达式转换为 [UiBinding]。
 *
 * 规则：
 * - 三种字面量直接折叠为 [UiBinding.literal]；
 * - 其他表达式（StateRef / Call / Interp / BinaryOp）统一按 EXPR 处理，bytes 由 [ExprSerializer] 产出；
 * - 事件绑定由调用方走 [emitEvent]，本类不做语义判断。
 */
class BindingEmitter {

    /** 普通 prop 的右值。 */
    fun emit(expr: ExprAst): UiBinding = when (expr) {
        is ExprAst.Literal.StringLit -> UiBinding.literal(expr.value)
        is ExprAst.Literal.NumberLit -> UiBinding.literal(NumberNormalizer.normalize(expr.value))
        is ExprAst.Literal.BoolLit -> UiBinding.literal(expr.value)
        else -> UiBinding.expr(ExprSerializer.serializeExpr(expr))
    }

    /** 事件 prop（如 onClick）右值。 */
    fun emitEvent(name: String): UiBinding = UiBinding.event(name)
}
